import { render, staticRenderFns } from "./Brackets.vue?vue&type=template&id=1e676437"
import script from "./Brackets.vue?vue&type=script&lang=js"
export * from "./Brackets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports